const state = {
  snackbar: {
    show: false,
    color: 'success',
    text: ''
  }
}

const mutations = {
  SHOW_SNACKBAR (state, {text, color = 'success'}) {
    state.snackbar.text = text
    state.snackbar.color = color
    state.snackbar.show = true
  },

  CLOSE_SNACKBAR (state) {
    state.snackbar.show = false
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/snackbar.js